import Breadcrumb, { BreadcrumbProps } from '../../components/Breadcrumb'
import { CoverSectionProps } from '../../components/CoverSection'
import { colors } from '../../theme'

export const onboardingCoverTransformer = (
  t: any,
  breadcrumbConfig: BreadcrumbProps
): CoverSectionProps => ({
  title: t('planning_cover_title') ?? '',
  backgroundColor: colors.greenEmerald,
  breadcrumb: (
    <>
      <Breadcrumb
        hoverColor={colors.greenEmerald}
        links={breadcrumbConfig.links}
      />
    </>
  ),
})
